(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-instagram"]) return;
  try {
    
  /*
    Watch the instagram feed to see when it's finished loading so we can check
    if it has any posts. If it does then show our container.
  */

  if (!document.querySelector && !window.MutationObserver && !("classList" in document.createElement("p"))) return;

  var container = document.querySelector('.product-section--instagram');
  var config = { attributes: true, childList: true, subtree: true };

  var onMutate = function (mutationsList, observer) {
    for(var mutation of mutationsList) {
      if (mutation.type == 'attributes') {
        if (mutation.target.classList.contains('showcase-gallery')) {
          if (mutation.target.classList.contains('has-posts')) {
            container.classList.remove('hide');
          }
          observer.disconnect();
        }
      }
    }
  };

  var observer = new MutationObserver(onMutate);
  observer.observe(container, config);

  } catch(e) { console.error(e); }
})();

})();
